import { render, staticRenderFns } from "./AttendanceHeader.vue?vue&type=template&id=930a2526&scoped=true"
import script from "./AttendanceHeader.vue?vue&type=script&lang=js"
export * from "./AttendanceHeader.vue?vue&type=script&lang=js"
import style0 from "./AttendanceHeader.vue?vue&type=style&index=0&id=930a2526&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930a2526",
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip,QIcon,QBtn,QMenu});
